export default __webpack_public_path__ + "static/media/fesaude-logo3.43b3c935.png";